
import {of as observableOf,  Observable } from 'rxjs';
import {take} from 'rxjs/operators';
/**
 * Created by christian cueni on 29.11.2016.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */

import { Injectable } from "@angular/core";

import { EventFormComponent } from "../components/event-form";

@Injectable()
export class EventChangesGuard  {
    constructor() {
    }

    canDeactivate(target: EventFormComponent): Observable<boolean> {
        if (target.hasChanges()) {
            return target.getUserConfirmation().pipe(take(1));
        } else {
            return observableOf(true);
        }
    }
}
